import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Pages
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Leads from '@/pages/Leads';
import Lenders from '@/pages/Lenders';
import Applications from '@/pages/Applications';
import Communications from '@/pages/Communications';
import FollowUps from '@/pages/FollowUps';
import PublicApplication from '@/pages/PublicApplication';
import BorrowerApplication from '@/pages/BorrowerApplication';
import LenderMatching from '@/pages/LenderMatching';
import TermSheets from '@/pages/TermSheets';
import SignTermSheet from '@/pages/SignTermSheet';
import Admin from '@/pages/Admin';
import LandingPage from '@/pages/LandingPage';
import HomePage from '@/pages/HomePage';
import EmailParser from '@/pages/EmailParser';
import SheetsSync from '@/pages/SheetsSync';
import Pricing from '@/pages/Pricing';
import ProtectedRoute from '@/components/layout/ProtectedRoute';
import MainLayout from '@/components/layout/MainLayout';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL hash
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/100-financing" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/apply" element={<PublicApplication />} />
      <Route path="/application/:token" element={<BorrowerApplication />} />
      <Route path="/sign/:termSheetId" element={<SignTermSheet />} />
      
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/lenders" element={<Lenders />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/followups" element={<FollowUps />} />
          <Route path="/communications" element={<Communications />} />
          <Route path="/lender-matching" element={<LenderMatching />} />
          <Route path="/term-sheets" element={<TermSheets />} />
          <Route path="/email-parser" element={<EmailParser />} />
          <Route path="/sheets-sync" element={<SheetsSync />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/admin" element={<Admin />} />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
